import { render, staticRenderFns } from "./PurchaseSelectShipper.vue?vue&type=template&id=7e5132a1&"
import script from "./PurchaseSelectShipper.vue?vue&type=script&lang=js&"
export * from "./PurchaseSelectShipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports